import { platformConfig, PlatformConfig } from '../config/platform';

const usePlatform = (): PlatformConfig => platformConfig;

export default usePlatform;
